import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { IncidentTypesService, IncidentTypeViewModel } from 'src/app/boxwood-api';
import { IncidentEvent, IncidentType } from 'src/app/hickory-api';

export interface IncidentSearchTypeData {
  pageTitle?: string;
  selectMultiple?: boolean;
  selected?: IncidentType[];
}
@Component({
  selector: 'app-incident-search-type',
  templateUrl: './search-type.component.html',
  styleUrls: ['./search-type.component.css'],
  standalone: false
})
export class IncidentSearchTypeComponent implements OnInit {
  incidentTypes: IncidentTypeViewModel[];
  filteredTypes: IncidentTypeViewModel[];
  filterText: string;
  typesLoading = true;

  constructor(
    private dialogRef: MatDialogRef<IncidentSearchTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IncidentSearchTypeData,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private incidentTypesApi: IncidentTypesService
  ) {
    if (!this.data) {
      this.data = { };
    }
  }

  ngOnInit() {
    this.fetchTypes();
  }

  fetchTypes() {
    this.incidentTypesApi.getIncidentTypesList().subscribe(result => {
      this.incidentTypes = result.sort((a, b) => {
        const aName = a.name.values[this.locale.language] ?? a.name.values['en'];
        const bName = b.name.values[this.locale.language] ?? b.name.values['en'];
        return (aName > bName) ? 1 : -1;
      });
      this.filteredTypes = this.incidentTypes;
      this.typesLoading = false;
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  filterChanged() {
    // Filter the results based on the search text
    this.filteredTypes = this.incidentTypes.filter(type => {

      // Case insensitive search the type name for the current language
      const typeName = type.name?.values[this.locale.language] ?? type.name?.values['en'];
      const nameContains = typeName?.toLowerCase().includes(this.filterText.toLowerCase());

      if (nameContains) {
        return true;
      }

      // Case insensitive search the category name
      const categoryContains = type.category?.name?.toLowerCase().includes(this.filterText.toLowerCase());

      if (categoryContains) {
        return true;
      }

      // Case insensitive search all keywords for each type
      // Do this only if we don't match on other fields
      // This operation will take the longest
      return type.metadata.tags?.keywords?.some(el => {
        return el.toLowerCase().includes(this.filterText.toLowerCase());
      });
    });
  }

  onTypeSelect(newType: IncidentTypeViewModel) {
    // Map between these types and add them to the list of selected types
    const incidentType: IncidentType = {
      id: newType.id,
      name: newType.name.values[this.locale.language] ?? newType.name.values['en'],
      showAssessment: newType.showAssessment,
      classification: newType.classification.name == "Emergency" ? "Emergency" : "Operations",
      loudToneSettings: newType.loudToneSettings,
    } 

    const incidentEvent: IncidentEvent = {
      incidentCategory: newType.category,
      incidentType: incidentType,
    }

    const incidentEvents: IncidentEvent[] = [];
    incidentEvents.push(incidentEvent);

    const data: IncidentSearchTypeData = { selected: incidentEvents };

    this.dialogRef.close(data);
  }

}
